jQuery.lib_flickity = function(callback) {
    if (!html.hasClass("ie9")) {
        $.importScript(cdnjs.flickity, function() {
            if (callback) {
                cssLoaded(function () {
                    callback();
                });
            }
        });
    }
};